import { render, staticRenderFns } from "./ynckWatch.vue?vue&type=template&id=0bfc8453&lang=html&"
import script from "./ynckWatch.vue?vue&type=script&lang=js&"
export * from "./ynckWatch.vue?vue&type=script&lang=js&"
import style0 from "./ynckWatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports